import Vue from 'vue';
import App from './App';
import Antd, { message } from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import router from './router';
import store from './store';

// import 'babel-polyfill';
import './utils/common';
import './utils/vlidator';
import './utils/filter';
import './permission';
import './utils/platform';

import chartOptions from './utils/chartOptions';
import Highcharts from 'highcharts/highstock';
import HighchartsMore from 'highcharts/highcharts-more';
import HighchartsDrilldown from 'highcharts/modules/drilldown';
import Highcharts3D from 'highcharts/highcharts-3d';
import variablePie from 'highcharts/modules/variable-pie';
import UIPackage from '@/components/common';
import SlideVerify from 'vue-monoplasty-slide-verify';

import './style/dataVisual/index.scss';
import './style/dataVisual/iconfont/iconfont.css';
import './style/dataVisual/font/custom.css';

import antAdminX, { GET, POST, DELETE, PUT, breadParam } from 'ant-design-vue-admin-x'; // todo

Vue.config.productionTip = false;

Vue.use(antAdminX);
Vue.use(Antd);
Vue.use(UIPackage);
Vue.use(SlideVerify);
HighchartsMore(Highcharts);
HighchartsDrilldown(Highcharts);
Highcharts3D(Highcharts);
variablePie(Highcharts);
Highcharts.setOptions(chartOptions.setOptions);

Vue.prototype.Highcharts = Highcharts;
Vue.prototype.breadParam = breadParam;

let config = { baseURL: process.env.VUE_APP_BASE_API_PHP };
let _get = GET.bind(config);
let _post = POST.bind(config);
let _delete = DELETE.bind(config);
let _put = PUT.bind(config);

Vue.prototype._get = _get;
Vue.prototype._post = _post;
Vue.prototype._delete = _delete;
Vue.prototype._put = _put;

const $get = GET.bind({});
const $post = POST.bind({});
const $delete = DELETE.bind({});
const $put = PUT.bind({});

Vue.prototype.$get = $get;
Vue.prototype.$post = $post;
Vue.prototype.$delete = $delete;
Vue.prototype.$put = $put;

message.config({ maxCount: 1 });

// const componentsContext = require.context('./components/common', false, /\.vue$/);
// componentsContext.keys().forEach(key => {
//   // 获取组件配置
//   const componentConfig = componentsContext(key);
//   Vue.component(`x-${componentConfig.default.name}`, componentConfig.default);
// });

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
});
